import React from 'react';
import Services from '../Services/Services';
import Banner from './Banner/Banner';
import './Home.css';
import About from '../About/About';
import Contact from '../Contact/Contact';
import { Button, Container, Row } from 'react-bootstrap';
import Works from '../Portfolio/Works/Works';
import { Link } from 'react-router-dom';
import miniProjects from '../../../Data/miniProjects';

const Home = () => {

    
    let work = miniProjects;

    return (
        <>
            <Banner></Banner>
            <About></About>
            <Services></Services>
            <section className="all-works">
                <Container>
                    <div className="text-center text-light py-5">
                        <h1>Most Popular Projects</h1>
                    </div>
                    <Row className="pb-4">
                        {
                            work.map(works => {
                                if (works.id < 5) {
                                    return <Works key={works.id} works={works}></Works>
                                }
                                return '';
                            })
                        }
                    </Row>
                    <div style={{ paddingBottom: '20px' }} className="text-center">
                        <Link to="/portfolio" className="details-link">
                            <Button style={{ backgroundImage: 'linear-gradient(90deg,#f61b10,#ef0963)', border: 'none' }} className="text-btn fs-6 fw-bold">
                                See More Works
                            </Button>
                        </Link>
                    </div>
                </Container>
            </section>
            <Contact></Contact>
        </>
    );
};

export default Home;